import { Component, OnInit } from '@angular/core';
import { firstValueFrom, Subject } from 'rxjs';
import { MemberActivityTypeModel } from 'src/app/member/shared/member-activity-type.model';
import { MemberService } from 'src/app/member/shared/member.service';
import { MemberActivity } from 'src/app/profiles/shared/model/member-activity.model';
import { ProfileService } from 'src/app/profiles/shared/profile.service';

@Component({
  selector: 'wl-profile-edit-drop-activity-dialog',
  templateUrl: './profile-edit-drop-activity-dialog.component.html',
  styleUrl: './profile-edit-drop-activity-dialog.component.less',
    standalone: false
})
export class ProfileEditDropActivityDialogComponent implements OnInit {
  public displayDropActivityDialog: boolean = false;
  public dropMemberActivities: Array<MemberActivityTypeModel> = [];
  public selectedDropActivity: MemberActivityTypeModel;
  private profileId: number;
  private entityId: number;
  private memberSince: Date;
  private _closed$ = new Subject<void>();

  constructor(private _memberService: MemberService, private _profileService: ProfileService) {}

  ngOnInit(): void {
    this._memberService.getMemberActivityDropCodes().then((result) => {
      this.dropMemberActivities = result;
    });
  }

  openDialog(profileId: number, entityId = 0): void {
    this.displayDropActivityDialog = true;
    this.profileId = profileId;
    this.entityId = entityId;
    this._profileService.getProfileMembershipInfoMin(this.profileId).then((membershipInfo) => {
      this.memberSince = membershipInfo.MemberSince;
    });
  }

  closeDialog(): void {
    this.displayDropActivityDialog = false;
    this.selectedDropActivity = null;
    this._closed$.next();
  }

  onClosed(): Promise<void> {
    return firstValueFrom(this._closed$);
  }

  createActivity(): void {
    if (this.selectedDropActivity) {
      let memberActivity = new MemberActivity();
      memberActivity.EntityId = this.entityId;
      memberActivity.ProfileId = this.profileId;
      memberActivity.ActivityType = this.selectedDropActivity.ActivityType;
      memberActivity.ActivityTypeId = this.selectedDropActivity.ActivityTypeID;
      memberActivity.MemberSince = this.memberSince;

      this._profileService.createMemberActivity(memberActivity).then(() => {
        this.closeDialog();
      });
    }
  }
}
